import { ReactNode, useState } from "react";
import { TOKEN_KEY, API_URL, BANK_CODES } from "./../../constants";
import { currencyFormatter } from "./../../functions";
import { ArrowLeftOutlined, CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import styles from "./show.module.css";
import { useParams, useNavigate } from "react-router-dom";
import {
    useShow,
    IResourceComponentsProps,
    useTranslate,
    useUpdate,
    useCustom,
    useLink,
    useExport
} from "@refinedev/core";
import { List, NumberField, RefreshButton, ExportButton } from "@refinedev/antd";

import { InvoiceActions, InvoiceStatus } from "components";

import {
    CheckCircleOutlined,
    CloseCircleOutlined as CloseIcon,
    LoadingOutlined,
    MobileOutlined,
} from "@ant-design/icons";

import {
    Row,
    Col,
    Button,
    Steps,
    Grid,
    Space,
    Avatar,
    Typography,
    Card,
    Table,
    Skeleton,
    Timeline,
    Input,
    Tag,
    Image,
    Alert,
    Descriptions,
    Modal,
    DatePicker,
    message,
    Popconfirm,
} from "antd";

const { Paragraph } = Typography;
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/pt_BR";
import axios from "axios";

import { BikeWhiteIcon } from "components/icons";
import { useOrderCustomKbarActions } from "hooks";
import { IEvent, IInvoice, IInvoiceStatus, IProduct, ISplit } from "interfaces";

import {
    Customer,
    CustomerBoxContainer,
    CustomerInfoBox,
    CustomerInfoBoxText,
    CustomerInfoText,
    PageHeader,
    Product,
    ProductFooter,
    ProductText,
} from "./styled";

const { useBreakpoint } = Grid;
const { Text } = Typography;

export const InvoiceShow: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();
    const screens = useBreakpoint();
    const navigate = useNavigate();
    const { queryResult } = useShow<IInvoice>();
    const { data, refetch } = queryResult;
    const { mutate } = useUpdate();
    const record = data?.data;
    const Link = useLink();

    const [renewOpen, setRenewOpen] = useState(false);
    const [renewDate, setRenewDate] = useState(dayjs().add(2, "day"));
    const [actionLoading, setActionLoading] = useState<"" | "cancel" | "renew">("");

    const apiHeaders = () => ({
        Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
        companyId: localStorage.getItem("companyId") || "",
    });

    console.log(record?.splitAll);
    
    // const split : any = record?.splitAll?.filter((item : any) => item.type!=="platform"); // ?.sort((a : any, b : any) => b.amount - a.amount);
    const split : any = record?.splitAll?.map((item : any) => {
        if(item.type!=="platform"){
            return {
                ...item
            }
        } else {
            return {
                ...item,
                name: "Custos e Taxas",
                amount: (Number(record.fees) + Number(record?.splitAll.filter((item : any) => item.type!=="platform").reduce((prev : any,curr : any) => prev + Number(curr.fees ?? 0),0)))
            }
        }
    });

    const total : any = (record?.gross ?? 0);

    let statusText = record?.statusText ?? "" as const;

    const canManageInvoice =
        statusText !== "Pagamento Aprovado" &&
        statusText !== "Reembolsado Parcial" &&
        statusText !== "Reembolsado Total";

    const handleCancel = async () => {
        if (!record?.id) return;
        setActionLoading("cancel");
        try {
            await axios.post(`${API_URL}/invoices/${record.id}/cancel`, {}, { headers: apiHeaders() });
            message.success("Guia cancelada com sucesso.");
            refetch();
        } catch (err: any) {
            message.error(err?.response?.data?.message || "Erro ao cancelar guia.");
        } finally {
            setActionLoading("");
        }
    };

    const handleRenew = async () => {
        if (!record?.id || !renewDate) return;
        setActionLoading("renew");
        try {
            const expireAtRaw = renewDate.format("YYYY-MM-DD");
            const { data: renewed } = await axios.post(
                `${API_URL}/invoices/${record.id}/renew`,
                { expireAtRaw },
                { headers: apiHeaders() }
            );
            message.success(`Nova guia #${renewed.id} criada com sucesso.`);
            setRenewOpen(false);
            navigate(`/invoices/show/${renewed.id}`);
        } catch (err: any) {
            message.error(err?.response?.data?.message || "Erro ao renovar guia.");
        } finally {
            setActionLoading("");
        }
    };

    const currentBreakPoints = Object.entries(screens).filter((screen) => !!screen[1]).map((screen) => screen[0]);

    const { triggerExport, isLoading: exportLoading } = useExport<any>({
        meta: {
            id: "bar",
        },
        mapData: (item) => {
            return item;
        },
        maxItemCount: 100,
    });

    const renderTransfer = () => {
        
        const {id} = useParams();
        const url = `${API_URL}/invoices/${id}/transactions`;
        const { data } = useCustom<{data: any;}>({ url, method: "get" });
        let items : any = data?.data;
        // items = items?.map((item : any) => { return { label: `${item.createdAt}`, children: `${item.type}` }})
        console.log(items);
        return (            
            <List
            headerProps={{ extra: <></>, }}
            title={
                <Text style={{ fontSize: 18, fontWeight: 800 }}>
                    Histórico
                </Text>
            }
            breadcrumb={<></>}
            >
                <Card>
                    <Row>
                        <Col xl={24} lg={24} md={24}>
                            <Timeline mode="left" items={items} />
                        </Col>
                    </Row>
                </Card>
            </List>
        );
    }

    const heroState =
        statusText === "Pagamento Aprovado"
            ? "paid"
            : statusText === "Cancelado"
            ? "canceled"
            : "pending";

    const renderTopbar = () => (
        <div className={styles.topbar}>
            <div className={styles.topbarLeft}>
                <button className={styles.backBtn} onClick={() => window.history.back()} aria-label="Voltar">
                    <ArrowLeftOutlined />
                </button>
                <span className={styles.pageTitle}>Cobrança #{record?.id ?? ""}</span>
            </div>
            <div className={styles.topbarActions}>
                {canManageInvoice && (
                    <>
                        <Popconfirm
                            title="Cancelar esta guia?"
                            description="A guia ficará marcada como cancelada e não poderá mais ser paga."
                            okText="Sim, cancelar"
                            cancelText="Voltar"
                            okButtonProps={{ danger: true, loading: actionLoading === "cancel" }}
                            onConfirm={handleCancel}
                        >
                            <Button
                                danger
                                icon={<CloseCircleOutlined />}
                                loading={actionLoading === "cancel"}
                                disabled={statusText === "Cancelado" || actionLoading === "renew"}
                            >
                                Cancelar guia
                            </Button>
                        </Popconfirm>
                        <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            loading={actionLoading === "renew"}
                            disabled={actionLoading === "cancel"}
                            onClick={() => {
                                setRenewDate(dayjs().add(2, "day"));
                                setRenewOpen(true);
                            }}
                        >
                            Renovar guia
                        </Button>
                    </>
                )}
                <RefreshButton resource="invoices" recordItemId={record?.id} />
            </div>
        </div>
    );

    const renderCustomerInfo = () => (
        <>
            {/* Hero de status / valor */}
            <div className={styles.hero} data-state={heroState}>
                <div className={styles.heroLeft}>
                    <span className={styles.heroLabel}>Pagador</span>
                    <span className={styles.payerName}>{record?.customer?.name}</span>
                    {record?.customer?.name !== record?.customer?.razaoSocial && (
                        <span className={styles.payerSub}>{record?.customer?.razaoSocial}</span>
                    )}
                    <div style={{ marginTop: 4 }}>
                        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                        {/* @ts-ignore */}
                        <InvoiceStatus status={statusText} />
                    </div>
                </div>
                <div className={styles.heroRight}>
                    <span className={styles.heroLabel}>Valor da cobrança</span>
                    <span className={styles.amountValue}>{currencyFormatter(total)}</span>
                    <span className={styles.amountMethod}>
                        {(record?.type ?? "").toString().toUpperCase()}
                        {record?.expireAt ? ` · venc. ${record?.expireAt}` : ""}
                    </span>
                </div>
            </div>

            {/* Grid de informações */}
            <div className={styles.infoGrid}>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Transação</span>
                    <span className={styles.infoValue}>#{record?.id}</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Forma de pagamento</span>
                    <span className={styles.infoValue}>{(record?.type ?? "").toString().toUpperCase()}</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Vencimento</span>
                    <span className={styles.infoValue}>{record?.expireAt ?? "-"}</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Código de pagamento</span>
                    <span className={styles.infoValue}>
                        {statusText === "Cancelado" ? (
                            <span style={{ color: "var(--color-error)" }}>⚠ Cobrança vencida ou cancelada</span>
                        ) : record?.paymentCode ? (
                            <Paragraph copyable style={{ margin: 0 }}>{record?.paymentCode}</Paragraph>
                        ) : (
                            "-"
                        )}
                    </span>
                </div>
                {record?.paymentUrl && statusText !== "Cancelado" && (
                    <div className={styles.infoItem}>
                        <span className={styles.infoLabel}>Link de pagamento</span>
                        <span className={styles.infoValue}>
                            <Link to={`${record?.paymentUrl}?format=pdf`}>Abrir link</Link>
                        </span>
                    </div>
                )}
            </div>

            {/* QR / boleto */}
            {record?.paymentImg && statusText !== "Cancelado" && (
                <Card className={styles.payCard} title={<span className={styles.sectionTitle}>{record?.type === "pix" ? "QR Code PIX" : "Boleto"}</span>}>
                    <Image.PreviewGroup>
                        <div className={styles.qrWrap}>
                            <Image width={record?.type === "pix" ? 180 : "100%"} src={record?.paymentImg ?? "https://"} />
                        </div>
                    </Image.PreviewGroup>
                </Card>
            )}
        </>
    );

    const renderSplit = () => (
        <List
            headerProps={{ extra: <></>
            // <ExportButton
            //     onClick={triggerExport}
            //     loading={exportLoading}
            // />
            }}
            title={
                <Text style={{ fontSize: 18, fontWeight: 800 }}>
                    {t("invoices.split.title")}
                </Text>
            }
            breadcrumb={<></>}
        >
            {split?.length && split?.filter((item : any) => item.type!=="platform" && item.status===0)?.length>0 && (
                <Alert
                    message="Após a aprovação do pagamento, as transferências levam cerca de até 3 dias úteis para trasferência completa"
                    // description="Additional description and information about copywriting."
                    type="info"
                    style={{marginBottom: 30}}
                    showIcon/>
            )}
            <Table
                pagination={false}
                dataSource={split}
                style={{overflow: "scroll"}}
                // footer={(_data) => (
                //     <ProductFooter>
                //         <Text>{t("invoices.split.mainTotal")}</Text>
                //         <NumberField
                //                 options={{
                //                     currency: "BRL",
                //                     style: "currency",
                //                 }}
                //                 locale="pt-BR" 
                //                 value={total}
                //         />                       
                //     </ProductFooter>
                // )}                
            >
                <Table.Column
                    defaultSortOrder="descend"
                    // sorter={(a: ISplit, b: ISplit) => a.price - b.price}
                    dataIndex="name"
                    title={t("invoices.split.fields.name")}
                    render={(value) => (
                        <Text style={{ fontWeight: 800 }}>{value}</Text>
                    )}                    
                />                
                <Table.Column
                    title={t("invoices.split.fields.account")}
                    dataIndex="account"
                    render={(value,record : any) => {
                        let account = record?.account?.find((item : any) => item?.id===record?.accountId);
                        return (
                        <>
                        <div
                        style={{
                            // display: "flex",
                            minWidth: 125,
                            // justifyContent: "space-between",
                        }}
                        >
                            <Text style={{ fontWeight: 800 }}>
                                {account?.bank}
                            </Text>
                            <br />
                            <Text style={{ fontWeight: 600 }}>
                                {account?.account} {account?.agency ? `(ag: ${account?.agency})` : ``}
                            </Text>
                            <br />
                            {record?.link && (
                            <Text style={{ fontWeight: 600 }}>
                                <a href={record?.link} target="_blank">{record?.link ? "Ver Comprovante" : ""}</a>
                            </Text>
                            )} 
                        </div>                       
                        </>
                        )
                    } }
                />
                <Table.Column
                    defaultSortOrder="descend"
                    // sorter={(a: ISplit, b: ISplit) => a.price - b.price}
                    dataIndex="statusText"
                    title={t("invoices.split.fields.status")}
                    render={(value,record : any) => {
                        console.log("record",record);
                        if(record?.type!=="platform"){
                            return (
                                <Tag color={(statusText==="Aguardando Pagamento" || statusText==="Cancelado" || value==="Cancelado/Erro") ? 'red' : (value==="Em Trânsito") ? 'orange' : 'green'}>
                                    {statusText==="Aguardando Pagamento" ? "Aguardando Pagamento" : (statusText==="Cancelado" || value==="Cancelado/Erro" ? "Cancelado/Erro" : value)}
                                </Tag>
                            )
                        } else {
                            return (<></>);
                        }
                    }}
                />
                <Table.Column
                    defaultSortOrder="descend"
                    // sorter={(a: ISplit, b: ISplit) => a.price - b.price}
                    dataIndex="amount"
                    title={t("invoices.split.fields.amount")}                    
                    render={(value) => {
                        return (
                            <>
                            <div
                            style={{
                                // display: "flex",
                                minWidth: 75,
                                // justifyContent: "space-between",
                            }}
                            >
                                <NumberField
                                    style={{ fontSize: 14, fontWeight: 600, color: "#52c41a" }}
                                    options={{
                                        currency: "BRL",
                                        style: "currency",
                                    }}
                                    locale="pt-BR" 
                                    value={value}
                                />
                            </div>
                            </>
                        );
                    }}
                />
                {/* <Table.Column
                    defaultSortOrder="descend"
                    sorter={(a: ISplit, b: ISplit) => a.price - b.price}
                    dataIndex="price"
                    title={t("invoices.split.fields.total")}
                    render={(value) => (
                        <Text style={{ fontWeight: 800 }}>{value}</Text>
                    )}
                /> */}
            </Table>
        </List>
    );

    // if(!record?.splitAll){
    //     return (<Skeleton />);
    // }

    return (
        <div className={styles.page}>
            {renderTopbar()}
            {renderCustomerInfo()}
            <Card className={styles.payCard}>
                {renderSplit()}
            </Card>
            <Card className={styles.payCard}>
                {renderTransfer()}
            </Card>
            <Modal
                title="Renovar guia"
                open={renewOpen}
                okText="Gerar nova guia"
                cancelText="Voltar"
                confirmLoading={actionLoading === "renew"}
                onOk={handleRenew}
                onCancel={() => setRenewOpen(false)}
            >
                <p style={{ marginBottom: 16 }}>
                    Será criada uma nova cobrança com os mesmos repasses e pagador, apenas com nova data de vencimento.
                </p>
                <label style={{ display: "block", marginBottom: 8, fontWeight: 600 }}>Novo vencimento</label>
                <DatePicker
                    locale={locale}
                    format="DD/MM/YYYY"
                    value={renewDate}
                    onChange={(d) => d && setRenewDate(d)}
                    disabledDate={(d) => d && d.isBefore(dayjs(), "day")}
                    style={{ width: "100%" }}
                />
            </Modal>
        </div>
    );
};
